import React, { useState, useEffect } from 'react';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import { FinCheck, FinChecks } from './FinField';
import '../css/financeiro-parcela-pagar.css';

/**
 * Confirmação para enviar na hora uma carta que já está na fila.
 *
 * O envio individual sai no mesmo request, mas se aquele participante já tem carta
 * enfileirada o back recusa por padrão: a carta vai sair, e mandar de novo agora seria
 * a segunda. Este modal é a saída consciente — tira a linha da fila e manda na hora.
 *
 * A caixa de seleção existe porque o botão sozinho seria clicado no reflexo de quem
 * acabou de ver "já está na fila" e quer resolver. O passo a mais é o ponto.
 */
export default function ModalForcarEnvio({ show, mensagem, onConfirmar, onFechar }) {
    const [certeza, setCerteza] = useState(false);

    // Zera a caixa toda vez que o modal reabre — deixar marcada de uma confirmação
    // anterior transformaria o passo a mais em nenhum passo.
    useEffect(() => {
        if (show) setCerteza(false);
    }, [show]);

    if (!show) return null;

    return (
        <div
            className="modal fade show d-block fin-pp fin-pp__modalbg"
            onClick={(e) => { if (e.target === e.currentTarget) onFechar(); }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content fin-pp__modal">
                    <div className="fin-pp__modal-head">
                        <span className="fin-pp__modal-head-ic is-danger"><FaExclamationTriangle size={17} /></span>
                        <h3 className="fin-pp__modal-title">
                            Enviar agora, fora da fila
                        </h3>
                        <button type="button" className="fin-pp__modal-close" onClick={onFechar}>
                            <FaTimes size={16} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <p style={{ marginBottom: 14 }}>
                            {mensagem || 'Esta carta já está na fila e será enviada.'}
                        </p>
                        <p style={{ marginBottom: 14 }}>
                            Confirmando, ela sai da fila e é enviada agora, neste momento. Faça isso
                            apenas se a pessoa precisa receber imediatamente — a fila existe para não
                            sobrecarregar o servidor de e-mail.
                        </p>
                        <FinChecks>
                            <FinCheck
                                id="forcar-envio-certeza"
                                label="Entendi e quero enviar agora"
                                checked={certeza}
                                onChange={(e) => setCerteza(e.target.checked)}
                            />
                        </FinChecks>
                    </div>
                    <div className="fin-pp__modal-foot">
                        <button type="button" className="fin-pp__btn" onClick={onFechar}>Cancelar</button>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--danger"
                            disabled={!certeza}
                            onClick={onConfirmar}>
                            Enviar agora
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
